/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import { beforeEnterWatcher } from "@/router/beforeEnterWatcher";
import { RouteConfig } from "vue-router";

export const appRoute: RouteConfig[] = [
    {
        beforeEnter: beforeEnterWatcher,
        children: [],
        component: () => import("@/views/App/AppView.vue"),
        path: '/app',
    },
]
